import { canViewFinanceTab } from "../../Project/helpers/project-finance-visibility.ts"
import type { PermissionProjectPermissions } from "../../SettingsPermissions/types/permissions.types.ts"

type Permissions = PermissionProjectPermissions | null | undefined

const mayViewFinances = (permissions: Permissions) =>
  canViewFinanceTab(permissions ?? undefined) ||
  !!permissions?.finances?.project_finance_full_access

/**
 * A project's sales price is money: shown only to a caller who may view
 * project finances, on top of the role flag that has always gated the column.
 * The API leaves the figure out for everyone else, so showing the column to
 * them would only show a column of blanks.
 */
export const canSeeProjectBudget = (permissions: Permissions): boolean =>
  !!permissions?.features?.project_show_budget && mayViewFinances(permissions)

/** Typing a new price in the list's inline editor changes the contract value. */
export const canEditProjectPrice = (permissions: Permissions): boolean =>
  canSeeProjectBudget(permissions) &&
  (!!permissions?.finances?.project_finance_edit ||
    !!permissions?.finances?.project_finance_full_access)

/** A saved sort on the price, which a caller who cannot see it must not keep. */
export const isPriceOrdering = (ordering: string | null | undefined) =>
  !!ordering &&
  ordering.split(",").some((term) => term.replace(/^-/, "") === "sales_price")
